<template>
	<div class="team">
		<Bannerinner/>
		<div class="titleinfo">
			<h3><a href="/">首页</a><em>></em><router-link :to="{path:'/team/index.html'}">冠领团队</router-link><em>></em></h3>
			<h2 class="linebox">
				<strong>冠领团队</strong>
				<em></em>
				<p>精诚团结&nbsp;&nbsp;&nbsp;&nbsp;超古冠今</p>
			</h2>
		</div>

		<div class="teamwrap">
			<div class="teambtn">
				<h2>按职位搜索：</h2>
				<div>
					<span @click="setZhiweiColor(index,item.lmid)" :class="{active: index == zhiweiIndex}"  v-for="item,index in zhiweiS" :key="index">{{item.name}}</span>
				</div>
			</div>

			<div class="teambtn chengshi">
				<h2>按城市搜索：</h2>
				<div>
					<span @click="setChengshiColor(item.lmid)" :class="{active:item.status}" v-for="item,index in chengshiS" :key="index">{{item.name}}</span>
				</div>
			</div>
			<!-- {{this.$store.state.team}} -->
			<div class="teambox" >
	
				
				<div class="teamitem">
					<!-- <h3 class="changetitle">{{cname}}</h3> -->
					<ol>
						<li v-for="item,index in teamData" :key="index" >
							<router-link class="iteminner" :to="{path:'/team/v/'+item.id+'.html'}">
							<img :src="item.thumb" alt="">
							<p>{{item.title}}</p>
						</router-link></li>
					</ol>
					<!-- <router-link to="/team/list/2.html" class="morelink">了解更多</router-link> -->
					<div class="page">
						<el-pagination
						background
						hide-on-single-page
						:current-page.sync=currentpage
						@current-change="getPage"
						layout="prev, pager, next"
						prev-text="上一页"
						next-text="下一页"
						:pager-count= pagerCount
						:total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>


<script>
	import $ from 'jquery'
	import {request} from '../network/request.js'
	import GLOBAL from '../global/global.js'
	import Bannerinner from '@/components/Bannerinner'
	import { title } from '../global/common.js'
	import { mapMutations } from 'vuex'
	export default{
		name:'Team',
		components:{
			Bannerinner
		},
		data(){
			return{
				show:true,
				currentIndex:99,
				zrData:[],
				cqData:[],
				gwData:[],
				sxData:[],
				zlData:[],
				comData:[],
				pageData:[],
				total:0,
				currentpage:1,
				pagerCount:5,
				pagesize:2,
				isshow:false,
				itempage:false,
				zhiweiIndex:0,
				zhiweilmid:13,
				chengshilmid:'',
				teamData:[],
				url:'/team/lschaxun?id=13&lssuoshu=&page=1&page_size=10',
				id:0,
				pagesize:1,
				origin:'',
				zhixing:0,
				lmid:0,
				pagetitle:'法律顾问',
				navList:[
					{id:0,name:'主任律师',lmid:13},
					{id:1,name:'法律顾问',lmid:31},
					{id:2,name:'拆迁律师',lmid:14},
					{id:3,name:'实习律师',lmid:15},
					{id:4,name:'律师助理',lmid:16}
				],
				zhiweiS:[
					{name:'主任律师','lmid':13,'zhiwei':'zhuren'},
					{name:'专家顾问','lmid':31,'zhiwei':'zhuanjia'},
					{name:'律师团队','lmid':14,'zhiwei':'lvshi'},
					{name:'律师助理','lmid':16,'zhiwei':'zhuli'},
					{name:'全 部','lmid':1000,'zhiwei':'all'}
					],
				chengshiS:[
					{name:'北京总所','lmid':1,'fensuo':'bj','status':false},
					{name:'上海冠领','lmid':2,'fensuo':'sh','status':false},
					{name:'深圳冠领','lmid':3,'fensuo':'sz','status':false},
					{name:'广州冠领','lmid':4,'fensuo':'gz','status':false},
					{name:'朝阳冠领','lmid':12,'fensuo':'cy','status':false},
					{name:'西安冠领','lmid':5,'fensuo':'xa','status':false},
					// {name:'昆明冠领','lmid':6,'fensuo':'km','status':false},
					{name:'武汉冠领','lmid':7,'fensuo':'wh','status':false},
					{name:'成都冠领','lmid':8,'fensuo':'cd','status':false},
					{name:'重庆冠领','lmid':9,'fensuo':'cq','status':false},
					{name:'杭州冠领','lmid':10,'fensuo':'hz','status':false},
					{name:'海淀冠领','lmid':11,'fensuo':'hd','status':false},
					{name:'长沙冠领','lmid':13,'fensuo':'cs','status':false},
					{name:'福州冠领','lmid':14,'fensuo':'fz','status':false},
					{name:'海口冠领','lmid':15,'fensuo':'hk','status':false},
					{name:'郑州冠领','lmid':16,'fensuo':'zz','status':false},
					{name:'合肥冠领','lmid':17,'fensuo':'hf','status':false},
					{name:'南宁冠领','lmid':18,'fensuo':'nn','status':false},
					{name:'贵阳冠领','lmid':19,'fensuo':'gy','status':false},
				]
			}
		},
		watch:{
			'$route':{
				deep: true,
				immediate: true,
				handler(to, from){
					this.zhiweiIndex = this.$store.state.team.zhiweiindex
					this.zhiweilmid = this.$store.state.team.zhiweilmid
					this.chengshilmid = this.$store.state.team.chengshilmid
					this.page = this.$store.state.team.page

					this.chengshiS.forEach(item => {
						if(item['lmid'] == this.chengshilmid){
							item['status'] = true
						}
					})


					if(this.zhiweilmid == 1000){
						this.url = '/team/allteam?lssuoshu='+this.chengshilmid
					}else{
						this.url = '/team/lschaxun?id='+this.zhiweilmid+'&lssuoshu='+this.chengshilmid
					}
					this.getData()
				}
			}
		},
		methods:{
			...mapMutations(['setVuex']),
			setZhiweiColor(index, lmid){
				this.zhiweiIndex = index
				this.zhiweilmid = lmid
				this.page = 1
				this.setVuex({'zhiweiindex':index,'zhiweilmid': lmid,'page':1})
				if(this.zhiweilmid == 1000){
					this.url = '/team/allteam?lssuoshu='+this.chengshilmid
				}else{
					this.url = '/team/lschaxun?id='+this.zhiweilmid+'&lssuoshu='+this.chengshilmid
				}
				this.getData()
			},
			setChengshiColor( lmid){
				this.chengshilmid = lmid
				this.page = 1
				this.setVuex({'chengshilmid':lmid,'page':1})
				this.chengshiS.forEach(item => {
					if(item['lmid'] ==  lmid){
						if(item['status']){
							this.setVuex({'chengshilmid':''})
							this.chengshilmid = ''
						}
						item['status'] = !item['status']
					}else{
						item['status'] = false
					}
				})
				if(this.zhiweilmid == 1000){
					this.url = '/team/allteam?lssuoshu='+this.chengshilmid
				}else{
					this.url = '/team/lschaxun?id='+this.zhiweilmid+'&lssuoshu='+this.chengshilmid
				}
				this.getData()
			},
			getAnLi(){
				let that = this
				request({
					url: '/anli/read?catid=7&id=1&page=1&page_size=3',
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							that.anliData = []
							let beforeData = jsondata['data']
							beforeData['data'].forEach(function(value,index,arr){
								if(value['thumb'].length > 100){
									let beforeimg = value['thumb'].split(':')[21];
									value['thumb'] = GLOBAL.httpurl+beforeimg.substr(1,beforeimg.length-4)
									value['create_time'] = value['create_time'].split(' ')[0]
								}
							})
						}
					}]
				})
			},
			getData(){
				let that = this
				request({
					url: 'http://api.guanlingls.com/index.php/api'+that.url+'&page='+that.page+'&page_size=9',
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							let beforeData = jsondata['data']
							beforeData['data'].forEach(function(value,index,arr){
								if(value['thumb'].length > 100){
									let beforeimg = value['thumb'].split(':')[21];
									value['thumb'] = GLOBAL.httpurl+beforeimg.substr(1,beforeimg.length-4)
								}
							})
							that.teamData = beforeData['data']
							that.total = jsondata['data']['total']
							that.currentpage = parseInt(jsondata['data']['current_page'])
						}
					}] 
				})
			},
			getPage(val){
				let that = this
				this.setVuex({'page':val})
				request({
					url: 'http://api.guanlingls.com/index.php/api'+that.url+'&page='+val+'&page_size=9',
					responseType: 'json',
					transformResponse:[function(data){
						let jsondata = JSON.parse(data)
						// console.log(jsondata);
						if(jsondata['code'] == 200){
							let beforeData = jsondata['data']
							beforeData['data'].forEach(function(value,index,arr){
								if(value['thumb'].length > 100){
									let beforeimg = value['thumb'].split(':')[21];
									value['thumb'] = GLOBAL.httpurl+beforeimg.substr(1,beforeimg.length-4)
								}
							})
							that.teamData = beforeData['data']
							that.total = jsondata['data']['total']
							that.currentpage = parseInt(jsondata['data']['current_page'])
						}
					}]
				})
			}
		}

	}
</script>

<style lang="scss" scoped>
.teamwrap{
    background: #fff;
    padding: 0 .3rem;
    overflow: hidden;
    margin-top: .15rem;
	padding-top: .2rem;
	.chengshi{
		margin-bottom: .2rem;
		margin-top: .15rem;
	}
    .teambtn{
        display: flex;
        flex-wrap: wrap;
        justify-content: start;
		align-items: start;
		h2{
			font-size: .28rem;
			color: #333;
			padding-top: .1rem;
			width: 1.7rem;
		}
		div{
			display: flex;
			flex-wrap: wrap;
			flex: 1;
		}
        span{
            font-size: .26rem;
            padding: .1rem .1rem;
            white-space: nowrap;
            color: #9b9494;
            transition: all .2s linear;
        }

        span.active{
            background-color: #eee;
            color: #c21a20;
        }
    }
    .teambox{
        .teamitem:last-child{
            border: none;
            padding-bottom: .2rem;
            margin-bottom: .1rem;
        }
        .teamitem{
            border-bottom: 1px solid #ececec;
            margin-bottom: .4rem;
            padding-bottom: .3rem;
            h3{
                position: relative;
                font-size: .32rem;
                color: #fff;
                height: .65rem;
                text-align: center;
                line-height: .65rem;
                margin-left: .25rem;
                margin-bottom: .3rem;
                width: 3.2rem;
                background: linear-gradient(to bottom, #dc4f49 5%, #c21a20 45%,#c21a20 55%, #dc4f49 100%);
            }
            h3::after{
                content: "";
                position: absolute;
                left: -.25rem;
                top: 0;
                width: .06rem;
                height: .65rem;
                background-color: #c21a20;
            }
            ol{
                display: flex;
                flex-wrap: wrap;
                justify-content: start;
                li{
                    width: 2.1rem;
                    border: none;
					height: 2.99rem;
                    padding: 0;
                    margin-bottom: .3rem;
					box-shadow: 0 0 .03rem #ccc;
					position: relative;
                    .iteminner{
						display: block;
						width: 100%;
						height: 2.99rem;
                        img{

                        }
                        p{
                            text-align: center;
                            background: #c21a20;
                            color: #fff;
                            height: .4rem;
                            line-height: .4rem;
                            font-size: .26rem;
							position: absolute;
							bottom: 0;
							width: 100%;
                        }
                    }
                }
                li:nth-child(3n+2){
                    margin: 0 .3rem;
                }
            }
        }
        .zhuren{
            padding-bottom: .1rem;
            h3{
                width: 2.25rem;
            }
            ul{
                
                li{
                    margin-bottom: .2rem;
                    .zhureninner{
                        display: flex;
                        .zrimg{
                            width: 2.5rem;
                            margin-right: .2rem;
                            img{
                                width: 2.5rem;
                                height: 3.07rem;
                            }
                            strong{
                                display: block;
                                text-align: center;
                                background: #c21a20;
                                color: #fff;
                                height: .4rem;
                                line-height: .4rem;
                                font-size: .26rem;
                            }
                        }
                        .zrinfo{
                            width: 5rem;
                            font-size: .26rem;
							
							.zrinfobox{
								display: flex;
								flex-wrap: wrap;
							}
                            p{
                                line-height: .4rem;
								// text-overflow: ellipsis;
								// display: -webkit-box;
								// -webkit-box-orient: vertical;
								// -webkit-line-clamp: 7;
								// overflow: hidden;
								// position: relative;
								em{
								    color: #e61e1e;
								    font-weight: bold;
									display: inline-block;
									padding-left: .1rem;
								} 
                            }
							
                        }
                    }
                }
            }
        }
    }
}
.myform{
    border-top: none !important;
}
</style>